import React, { Component } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import './Typography.scss'

class Link extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isActive: false
        }
    }

    componentDidMount() {
        this.setState({
            isActive: window.location.href === (window.location.pathname + window.location.hash) ? 'active' : false
        })
    }

    render() {
        return(
            <a className={cx('link', this.props.arrow && 'arrow', this.props.className, this.props.color, this.props.model, this.props.weight, this.state.isActive)}
                href={!this.state.isActive ? this.props.href : undefined}
                onClick={this.props.onClick}
                onMouseOver={this.props.onMouseOver}
                target={this.props.target}
                title={this.props.title}
                rel={this.props.rel ? this.props.rel : this.props.target === '_blank' ? 'noopener noreferrer' : ''}
                ref={this.props.linkRef}>
                {this.props.children}
            </a>
        )
    }
}

Link.defaultProps = {
    color: 'linkDark',
    model: 'initial-underline',
    weight: 'medium'
}

Link.propTypes = {
    color: PropTypes.oneOf(['linkDark', 'linkLight', 'green', 'white', 'linkBlack']),
    model: PropTypes.oneOf(['initial-underline', 'hover-underline']),
    target: PropTypes.oneOf(['_blank', '_parent', '_self', '_top']),
    weight: PropTypes.oneOf(['thin', 'extra-light', 'light', 'regular', 'medium', 'semi-bold', 'bold', 'extra-bold', 'black'])
}

export default Link



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/typography/Link.jsx